import React, { Component } from 'react';
import '../App.css';

var days=['א','ב','ג','ד','ה','ו','ז','ח','ט','י','יא','יב','יג','יד','טו','טז','יז','יח','יט','כ','כא','כב','כג','כד','כה','כו','כז','כח','כט'];
class DropdownDay extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      showMenu: false,
      day: this.props.currentDay, 
    };
    
    this.generateDropdownItems = this.generateDropdownItems.bind(this);
    this.showCloseMenu = this.showCloseMenu.bind(this);
  }
  
  showCloseMenu(event) {
    event.preventDefault();
    this.setState({ showMenu: !this.state.showMenu});
  }
  
  chooseDay(event){
    this.setState({day: days[parseInt(event.target.id.slice(2))], showMenu:false});
    this.props.updateDay(days[parseInt(event.target.id.slice(2))]);
  }

  generateDropdownItems(){
    let buttons =[];
    if(this.props.isWholeMonth)
    {
        if(days.length===29)
            days.push('ל');
    }
    for(let i=0;i<days.length;i++)
    {
        buttons.push(<button className="dropdown-item" id={"bd"+i} key={i} onClick={this.chooseDay.bind(this)}>{days[i]}</button>);
    }
    return buttons;
  }

  render() {
    return (
      <div>
        
        <button className="btn dropdown-toggle" onClick={this.showCloseMenu}>
          {"  "+this.state.day+"  "}
        </button>
        
        {
          this.state.showMenu
            ? (
              <div>
                <div className="overlay" onClick={this.showCloseMenu}></div>
                <div className="dropdown-menu" >
                  {this.generateDropdownItems()}
                </div>
              </div>
            )
            : (
              null
            )
        }
      </div>
    );
  }
}

export default DropdownDay;


// WEBPACK FOOTER //
// ./src/components/DropdownDay.js